import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonColor } from 'src/app/model';

@Component({
  selector: 'app-export-confirm',
  templateUrl: './export-confirm.component.html',
  styleUrl: './export-confirm.component.css'
})
export class ExportConfirmComponent {
  buttonColor = ButtonColor.SECONDARY;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>) {}

  onFormActionClick(action) {
    if(action === 'yes'){
      this.dialogRef?.close(true);
    } else {
      this.dialogRef?.close();
    }
  }

}
